import {gql} from "@apollo/client";

export const POST_JOB_SCHEDULE = gql`
	mutation postSchedule ($scheduleInput: PostScheduleInput!) {
		postSchedule(input: $scheduleInput) {
			schedule {id}
		}
	}
`;
